/** Max columns in the tools catalog grid (keeps cards readable on wide displays). */
export const TOOL_GRID_MAX_COLUMNS = 3;

/**
 * Prefer not to go narrower than this per card so title + description stay readable.
 */
export const TOOL_GRID_MIN_CARD_WIDTH = 260;

/**
 * @param {number} bodyWidth — measured grid row width (px)
 * @param {number} gap — horizontal gap between cards (px)
 * @returns {number} column count in [1, TOOL_GRID_MAX_COLUMNS]
 */
export function getToolGridColumnCount(bodyWidth, gap = 16) {
  const w = typeof bodyWidth === 'number' && bodyWidth > 0 ? bodyWidth : 360;
  const eff = Math.max(160, w);
  for (let n = TOOL_GRID_MAX_COLUMNS; n >= 1; n -= 1) {
    const slot = (eff - (n - 1) * gap) / n;
    if (slot >= TOOL_GRID_MIN_CARD_WIDTH) return n;
  }
  return 1;
}

/**
 * @param {number} bodyWidth
 * @param {number} columnCount
 * @param {number} gap
 * @returns {number}
 */
export function getToolGridCardWidthPx(bodyWidth, columnCount, gap = 16) {
  if (columnCount < 1) return Math.max(1, Math.floor(bodyWidth));
  const w = typeof bodyWidth === 'number' && bodyWidth > 0 ? bodyWidth : 360;
  const eff = Math.max(160, w);
  return Math.max(1, Math.floor((eff - (columnCount - 1) * gap) / columnCount));
}
